/* eslint-disable react/display-name */
import React, { ReactNode } from 'react';

import { Currency } from '~components/form-fields/inputs';
import Icon, { faCheck, faXmark } from '~components/icon';

export function genericCellRender(mapper: (value: any) => ReactNode, wrapInDiv = true) {
  return (value: any, className?: string) =>
    wrapInDiv ? <div className={className}>{mapper(value)}</div> : mapper(value);
}

export function checkboxCellRender() {
  return (value: boolean, className?: string) => (
    <div className={className}>
      {value ? <Icon icon={faCheck} color="green" /> : <Icon icon={faXmark} color="red" />}
    </div>
  );
}

export function currencyCellRender(id: string, noDecimals = false, zeroDisplay?: ((row: any, value: number) => React.ReactNode) | string) {
  return (value: number, className?: string, row?: any) => {
    const useZeroDisplay = value === null || isNaN(value) || (zeroDisplay && typeof zeroDisplay === 'function' && zeroDisplay(row, value));

    if (useZeroDisplay) {
      const placeholder =
        typeof zeroDisplay === 'function'
          ? zeroDisplay(row, value)
          : zeroDisplay ?? '-';

      return <div className={className}>{placeholder}</div>;
    }

    return (
      <Currency
        id={id}
        name={id}
        type="readonly"
        value={value}
        className={className}
        noDecimals={noDecimals}
        disabled
      />
    );
  };
}
